<template>
    <v-container fluid fill-height>
        <v-card color="transparent" outlined width="100%" class="fill-height pt-5 pb-5 mt-5 mb-5">
            <v-toolbar color="transparent" flat height="50">
                <v-toolbar-title>
                    <v-chip label color="amber"><v-icon class="mr-3">mdi-reorder-horizontal</v-icon> ORDERS</v-chip>
                    
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down">
                    <a v-for="(menu, i) in menuProduct" :key="i" :href="`/orders/${menu.id}`" class="ancSetting">
                    <v-btn :color="currentmenu == menu.id ? 'amber' : 'grey lighten-2'"
                    :class="`text-uppercase orderButton ml-5 elevation-0`" x-small>
                         {{menu.name}} 
                    </v-btn></a>
                </v-toolbar-items>
            </v-toolbar>         
        </v-card>
        <v-tabs v-model="OrderManagerTabs" background-color="blue-grey darken-1" color="amber" grow dark>
            <v-tab>Pending</v-tab>
            <v-tab color="green">Approved</v-tab>
            <v-tab>Not Approved</v-tab>
        </v-tabs>
        <v-tabs-items v-model="OrderManagerTabs" style="width:100%">
            <v-tab-item>
                <v-card class=mt-5 style="width:100%" outlined>
                    <v-card-text>
                        <v-col cols="12" mb-5>
                            <v-btn v-if="Selection.length > 0" small color="red" dark @click="deleteBox=true">Delete</v-btn>
                        </v-col>
                        <v-data-table v-if="formType == 'PurchaseFormA'" 
                        v-model="Selection" :show-select="role == 'admin' ? true : false"
                        :headers="purchaseFormAHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='PurchaseFormA';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                        <v-data-table v-if="formType == 'PurchaseFormB'" 
                        v-model="Selection" :show-select="role == 'admin' ? true : false"
                        :headers="purchaseFormBHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='PurchaseFormB';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                        <v-data-table v-if="formType == 'PurchaseFormC'" 
                        v-model="Selection" :show-select="role == 'admin' ? true : false"
                        :headers="purchaseFormCHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='PurchaseFormC';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                        <v-data-table v-if="formType == 'SaleFormA'" 
                        v-model="Selection" :show-select="role == 'admin' ? true : false"
                        :headers="saleFormAHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='SaleFormA';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                        <v-data-table v-if="formType == 'SaleFormB'" 
                        v-model="Selection" :show-select="role == 'admin' ? true : false"
                        :headers="saleFormBHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='SaleFormB';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card class=mt-5 style="width:100%" outlined>
                    <v-card-text>
                        <v-data-table v-if="formType == 'PurchaseFormA'" :headers="purchaseFormAFinalHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='PurchaseFormA';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                        <v-data-table v-if="formType == 'PurchaseFormB'" :headers="purchaseFormBFinalHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='PurchaseFormB';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                        <v-data-table v-if="formType == 'PurchaseFormC'" :headers="purchaseFormCFinalHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='PurchaseFormC';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                        <v-data-table v-if="formType == 'SaleFormA'" :headers="saleFormAFinalHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='SaleFormA';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                        <v-data-table v-if="formType == 'SaleFormB'" :headers="saleFormBFinalHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='SaleFormB';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card class=mt-5 style="width:100%" outlined>
                    <v-card-text>
                        <v-col cols="12" mb-5>
                            <v-btn v-if="Selection.length > 0" small color="red" dark @click="deleteBox=true">Delete</v-btn>
                        </v-col>
                        <v-data-table v-if="formType == 'PurchaseFormA'" 
                        v-model="Selection" :show-select="role == 'admin' ? true : false"
                        :headers="purchaseFormAHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='PurchaseFormA';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                        <v-data-table v-if="formType == 'PurchaseFormB'" 
                        v-model="Selection" :show-select="role == 'admin' ? true : false"
                        :headers="purchaseFormBHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='PurchaseFormB';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                        <v-data-table v-if="formType == 'PurchaseFormC'" 
                        v-model="Selection" :show-select="role == 'admin' ? true : false"
                        :headers="purchaseFormCHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='PurchaseFormC';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                        <v-data-table v-if="formType == 'SaleFormA'" 
                        v-model="Selection" :show-select="role == 'admin' ? true : false"
                        :headers="saleFormAHeader" :items="tabledata" style="color:red;">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='SaleFormA';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                        <v-data-table v-if="formType == 'SaleFormB'" 
                        v-model="Selection" :show-select="role == 'admin' ? true : false"
                        :headers="saleFormBHeader" :items="tabledata">
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditFormType='SaleFormB';orderId=item.id;orderdilog=true"><v-icon>mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
        <v-dialog v-model="orderdilog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <!-- ============ PURCHASE FORM A ============== -->
            <purchaseFormA 
            v-if="EditFormType == 'PurchaseFormA'"
            :orderId="orderId"
            @Response="action($event)"
            @Close="orderdilog = false"
            ></purchaseFormA>
            <!-- =============== PURCHASE FORM B ============ -->
            <purchaseFormB 
            v-if="EditFormType == 'PurchaseFormB'"
            :orderId="orderId"
            @Response="action($event)"
            @Close="orderdilog = false"
            ></purchaseFormB>
            <!-- =========== PURCHASE FORM C ============== -->
            <purchaseFormC 
            v-if="EditFormType == 'PurchaseFormC'"
            :orderId="orderId"
            @Response="action($event)"
            @Close="orderdilog = false"
            ></purchaseFormC>
            <!-- ============ SALES FORM A ================= -->
            <saleFormA 
            v-if="EditFormType == 'SaleFormA'"
            :orderId="orderId"
            @Response="action($event)"
            @Close="orderdilog = false"
            >
            </saleFormA>
            <!-- ============ SALES FORM B ================= -->
            <saleFormB 
            v-if="EditFormType == 'SaleFormB'"
            :orderId="orderId"
            @Response="action($event)"
            @Close="orderdilog = false"
            >
            </saleFormB>
        </v-dialog>
        <v-dialog v-model="deleteBox" scrollable persistent max-width="500px" transition="dialog-transition">
            <delConfirm :url="delUrl" :selectedId="deleteconveter" ></delConfirm>
        </v-dialog>

        <v-snackbar v-model="notificationBar" top center :color="notificationColor" multi-line> {{ notificationText }}
            <v-btn color="amber" text @click="notificationBar = false"> Close </v-btn>
        </v-snackbar>

    </v-container>
</template>
<script>
import { SERVER_API } from '../../API';
import purchaseFormA from '../../components/editdata/purchaseFormA'
import purchaseFormB from '../../components/editdata/purchaseFormB'
import purchaseFormC from '../../components/editdata/purchaseFormC'
import SaleFormA from '../../components/editdata/saleFormA'
import SaleFormB from '../../components/editdata/saleFormB'
import delConfirm from '../../components/confirmation/index.vue'
import {store} from '../../store/index'
import {bus} from '../../main'
export default {
    components:{purchaseFormA,purchaseFormB,purchaseFormC,SaleFormA,SaleFormB,delConfirm},
    mounted(){
        this.fetchProduct();
        this.productFindbyid();
        this.open();
    },
    created(){
        bus.$on('notify',() =>{
            this.fetchProduct();
            this.productFindbyid();
            this.open();
        }),
        bus.$on('close',() =>  {
            this.deleteBox = false;
            this.Selection = [];
        });
        bus.$on('deleted', () =>  {
            for(let i = 0; i < this.Selection.length; i++){
                if(this.tabledata.indexOf(this.Selection[i])!= -1){
                    this.tabledata.splice(this.tabledata.indexOf(this.Selection[i]),1);
                }
            }
            this.Selection = [];
        }); 
    },
    computed:{
        tabcheck(){
          return  this.tabsetting();
        },
        deleteconveter(){
            var deleteId = [...new Set(this.Selection.map(it => it.id))];
            return deleteId.toString();
        }
    },
    
    data(){
        return{
            //Selection
            delUrl:SERVER_API+'/order/delete',
            Selection:[],
            role: store.state.role,
            OrderManagerTabs:0,
            //
            EditFormType:'',
            orderId:'',
            orderdilog:false,
            currentmenu: this.$route.params.product,
            menuProduct:[],
            formType:'',
            notificationBar:'',
            notificationColor:'black',
            notificationText:'',
            tabledata:[],
            approvedData:'',
            pendingData:[],
            deleteBox:false,
            //PurchaseFormAHeader
            purchaseFormAHeader:[
                {text:'Order Id', value:"id"},
                {text:'Order date', value:"createdAt"},
                {text:'Order By', value:"customer"},
                {text:'Order Cond.', value:"conditionType"},
                {text:'Order Type', value:"orderType"},
                {text:'Demand Rate', value:"dRate"},
                {text:'Oil Content', value:"oilContent"},
                {text:'Offer Qty/Tons', value:"oQty"},               
                {text:'Offer Rate/Qtl', value:"oRate"},
                {text:'Action', value:"action"},
            ],
            purchaseFormAFinalHeader:[
                {text:'Order Id', value:"id"},
                {text:'Bargain No', value:"bargainNo"},
                {text:'Order date', value:"createdAt"},
                {text:'Order By', value:"customer"},
                {text:'Order Cond.', value:"conditionType"},
                {text:'Order Type', value:"orderType"},
                {text:'Oil Content', value:"oilContent"},
                {text:'Demand Rate', value:"dRate"},
                {text:'Offer Qty/Tons', value:"oQty"},
                {text:'Offer Rate/Qtl', value:"oRate"},
                {text:'Final Qty/Tons', value:"fQty"},
                {text:'Final Rate', value:"fRate"},
                {text:'Final date', value:"updatedAt"},
                {text:'Action', value:"action"},
            ],
            //PurchaseFormBHeader
            purchaseFormBHeader:[
                {text:'Order Id', value:"id"},
                {text:'Order date', value:"createdAt"},
                {text:'Order By', value:"customer"},
                {text:'Order Cond.', value:"conditionType"},
                {text:'Order Type', value:"orderType"},
                {text:'Demand Rate', value:"dRate"},
                {text:'Offer Qty/Tons', value:"oQty"},
                {text:'Offer Rate', value:"oRate"},
                {text:'Action', value:"action"},
            ],
            purchaseFormBFinalHeader:[
                {text:'Order Id', value:"id"},
                {text:'Bargain No', value:"bargainNo"},
                {text:'Order date', value:"createdAt"},
                {text:'Order By', value:"customer"},
                {text:'Order Cond.', value:"conditionType"},
                {text:'Order Type', value:"orderType"},
                {text:'Demand Rate', value:"dRate"},
                {text:'Offer Qty/Tons', value:"oQty"},
                {text:'Offer Rate', value:"oRate"},
                {text:'Final Qty/Tons', value:"fQty"},
                {text:'Final Rate', value:"fRate"},
                {text:'Final date', value:"updatedAt"},
                {text:'Action', value:"action"},
            ],

            //PurchaseFormCHeader
            purchaseFormCHeader:[
                {text:'Order Id', value:"id"},
                {text:'Order date', value:"createdAt"},
                {text:'Order By', value:"customer"},
                {text:'Order Type', value:"orderType"},
                {text:'Demand Rate', value:"dRate"},
                {text:'Offer Qty/Tons', value:"oQty"},
                {text:'Offer Rate', value:"oRate"},
                {text:'Location.', value:"location"},
                {text:'Action', value:"action"},
            ],

             purchaseFormCFinalHeader:[
                 {text:'Order Id', value:"id"},
                {text:'Bargain No', value:"bargainNo"},
                {text:'Order date', value:"createdAt"},
                {text:'Order By', value:"customer"},
                {text:'Location.', value:"location"},
                {text:'Order Type', value:"orderType"},
                {text:'Demand Rate', value:"dRate"},
                {text:'Offer Qty/Tons', value:"oQty"},                
                {text:'Offer Rate', value:"oRate"},
               // {text:'Loading Date', value:"oLoadingDate"},                
                {text:'Final Qty/Tons', value:"fQty"},
                {text:'Final Rate', value:"fRate"},
                {text:'Final date', value:"updatedAt"},
                {text:'Action', value:"action"},
            ],

            //SaleFormAHeader
            saleFormAHeader:[
                {text:'Order Id', value:"id"},
                {text:'Order date', value:"createdAt"},
                {text:'Order By', value:"customer"},
                {text:'Order Cond.', value:"conditionType"},
                {text:'Order Type', value:"orderType"},
                {text:'Demand Rate', value:"dRate"},
                {text:'Offer Rate', value:"oRate"},
                {text:'Offer Qty/Tons', value:"oQty"},
                //{text:'Loading Date', value:"oLoadingDate"},
                //{text:'Payment Date', value:"oPaymentDate"},
                {text:'Action', value:"action"},
            ],

            saleFormAFinalHeader:[
                {text:'Order Id', value:"id"},
                {text:'Bargain No', value:"bargainNo"},
                {text:'Order date', value:"createdAt"},
                {text:'Order By', value:"customer"},
                {text:'Order Cond.', value:"conditionType"},
                {text:'Order Type', value:"orderType"},
                {text:'Demand Rate', value:"dRate"},
                {text:'Offer Rate', value:"oRate"},
                {text:'Offer Qty/Tons', value:"oQty"},
                //{text:'Loading Date', value:"oLoadingDate"},
                //{text:'Payment Date', value:"oPaymentDate"},                
                {text:'Final Qty/Tons', value:"fQty"},
                {text:'Final Rate', value:"fRate"},
                {text:'Final date', value:"updatedAt"},
                {text:'Action', value:"action"},
            ],

            //SaleFormBHeader
            saleFormBHeader:[
                {text:'Order Id', value:"id"},
                {text:'Order date', value:"createdAt"},
                {text:'Order By', value:"customer"},
                {text:'Order Type', value:"orderType"},
                {text:'Order Cond.', value:"conditionType"},
                {text:'Demand Rate', value:"dRate"},
                {text:'Payment Type', value:"paymentCond"},
                {text:'Offer Qty/Tons', value:"oQty"},
                {text:'Offer Rate', value:"oRate"},                
                {text:'Action', value:"action"},
            ],

            saleFormBFinalHeader:[
                {text:'Order Id', value:"id"},
                {text:'Bargain No', value:"bargainNo"},
                {text:'Order date', value:"createdAt"},
                {text:'Order By', value:"customer"},
                {text:'Order Type', value:"orderType"},
                {text:'Order Cond.', value:"conditionType"},
                {text:'Demand Rate', value:"dRate"},
                {text:'Payment Type', value:"paymentCond"},
                {text:'Offer Qty/Tons', value:"oQty"},
                {text:'Offer Rate', value:"oRate"},
                {text:'Final Qty/Tons', value:"fQty"},
                {text:'Final Rate', value:"fRate"},
                {text:'Final date', value:"updatedAt"},
                {text:'Action', value:"action"},
            ],
            
        }
    },
    watch:{
        OrderManagerTabs(val){
            if(val !== ''){
                this.fetchOrders();
            }
        },
        tabcheck(){
            //
        }
    },
    methods:{
        tabsetting(){
            if(this.$route.query.type == 'pending'){
                this.OrderManagerTabs = 0
            }
            if(this.$route.query.type == 'approved'){
                this.OrderManagerTabs = 1
            }
            if(this.$route.query.type == 'notap'){
                this.OrderManagerTabs = 2
            }
        },
        async open(){
            await this.$http.get(SERVER_API+'/order/open/product/'+this.$route.params.product);
        },
        action(e){
            if(e.action == true){
                this.notificationColor = 'black';
                this.notificationBar = true;
                this.notificationText = e.message;
                this.orderdilog=false;
                this.fetchOrders();
            }else{
                this.notificationColor = 'red';
                this.notificationBar = true;
                this.notificationText = e.message;            
            }

        },
        async productFindbyid(){
            const response = await this.$http.get(SERVER_API+'/product/byid/'+this.$route.params.product);
            this.formType = response.data.data.pF;
            await this.fetchOrders();
        },

        async fetchOrders(){
            var url;
            if(this.formType == 'PurchaseFormA'){
                if(this.OrderManagerTabs == 0){
                    url = SERVER_API+'/order/backend/pending/purchaseforma/'+this.$route.params.product;
                }else if(this.OrderManagerTabs == 1){
                    url = SERVER_API+'/order/backend/approved/purchaseforma/'+this.$route.params.product;
                }else{
                   url = SERVER_API+'/order/backend/notapproved/purchaseforma/'+this.$route.params.product; 
                }
            }
            if(this.formType == 'PurchaseFormB'){
                if(this.OrderManagerTabs == 0){
                    url = SERVER_API+'/order/backend/pending/purchaseformb/'+this.$route.params.product;
                }else if(this.OrderManagerTabs == 1){
                    url = SERVER_API+'/order/backend/approved/purchaseformb/'+this.$route.params.product;
                }else{
                   url = SERVER_API+'/order/backend/notapproved/purchaseformb/'+this.$route.params.product; 
                }
            }
            if(this.formType == 'PurchaseFormC'){
                if(this.OrderManagerTabs == 0){
                    url = SERVER_API+'/order/backend/pending/purchaseformc/'+this.$route.params.product;
                }else if(this.OrderManagerTabs == 1){
                    url = SERVER_API+'/order/backend/approved/purchaseformc/'+this.$route.params.product;
                }else{
                   url = SERVER_API+'/order/backend/notapproved/purchaseformc/'+this.$route.params.product; 
                }
            }
            if(this.formType == 'SaleFormA'){
                if(this.OrderManagerTabs == 0){
                    url = SERVER_API+'/order/backend/pending/saleforma/'+this.$route.params.product;
                }else if(this.OrderManagerTabs == 1){
                    url = SERVER_API+'/order/backend/approved/saleforma/'+this.$route.params.product;
                }else{
                   url = SERVER_API+'/order/backend/notapproved/saleforma/'+this.$route.params.product; 
                }
            }
            if(this.formType == 'SaleFormB'){
                if(this.OrderManagerTabs == 0){
                    url = SERVER_API+'/order/backend/pending/saleformb/'+this.$route.params.product;
                }else if(this.OrderManagerTabs == 1){
                    url = SERVER_API+'/order/backend/approved/saleformb/'+this.$route.params.product;
                }else{
                   url = SERVER_API+'/order/backend/notapproved/saleformb/'+this.$route.params.product; 
                }
            }
            const response = await this.$http.get(url);
            this.tabledata = response.data.data;

        },
        async fetchProduct(){
            try{
                const response = await this.$http.get(SERVER_API+'/product/byuser');
                this.menuProduct = response.data.data;
            }catch(error){
                alert(error);
            }
        }
    }

}
</script>

<style>
.tablefontsize .v-data-table__wrapper table tbody tr td{
    font-size: 10px !important;
}
.tablefontsize .v-data-table__wrapper table thead tr th{
    font-size: 10px !important;
    font-weight: bold;
    color:#000;
}
.orderButton{
    height:30px !important;
}
.ancSetting{
    text-decoration: none;
}
</style>